import { PipeTransform, Pipe } from '@angular/core';
import { Router } from '@angular/router';

@Pipe({
    name: 'mainMenuItemClass',
    pure: false
})
export class PipeMainMenuItemClass implements PipeTransform {
    transform(action: any, router : Router): any {
        var cls = [action?.goTo && router.url.substr(1).indexOf(action?.goTo.join('/')) > -1? 'active' : '', action?.params?.class? action.params.class : ''];

        return cls;
    }
}